<template>
  <div id="contenedor" ref="History">
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card
            cols="12"
            class="pa-xs-2 pa-md-2 pa-lg-2 mt-xs-0 mt-md-0 mt-lg-0 mb-7"
          >
            <v-card-title>HISTORIAL PEDIDO</v-card-title>
            <v-row>
              <v-col cols="12" md="8">
                <date-range-selector class="mt-5" @onClick="getHistoryByDate" />
              </v-col>
              <v-col cols="12" md="4">
                <v-row class="mt-10" justify="end">
                  <search-input v-model="search" class="search-input-width" />
                </v-row>
              </v-col>
            </v-row>
            <br />
            <order-history-table
              :items="data"
              :search="search"
              height="auto"
              @onPDFClick="getPDFXMLInvoice"
              @onEmailPDFClick="senDEmail"
              @onEmailComClick="senDEmailComp"
              @onOrderDetail="detallePedido"
              @onDeliveryDetail="deliveryDetail"
            />
          </v-card>
        </v-col>
      </v-row>
      <br />
      <v-card
        id="backorders"
        cols="12"
        class="pa-xs-2 pa-md-2 pa-lg-2 mt-xs-0 mt-md-0 mt-lg-0 mb-7"
      >
        <v-card-title>HISTORIAL CARRITOS</v-card-title>
        <recent-orders-viewer
          v-if="customer_code"
          :customer-code="customer_code"
        />
      </v-card>

      <!-- Request For quotation history table -->
      <v-card
        cols="12"
        class="pa-xs-2 pa-md-2 pa-lg-2 mt-xs-0 mt-md-0 mt-lg-0 mb-15"
      >
        <v-card-title>COTIZAS BAJO PEDIDO</v-card-title>

        <div class="d-flex justify-space-between mx-4">
          <v-btn color="red" dark :to="{ name: 'QuotationTracking' }">
            Seguimiento Cotz.
            <v-icon>mdi-list-box-outline</v-icon>
          </v-btn>
          <search-input v-model="quotationSearch" class="search-input-width" />
        </div>

        <request-for-quotation-table
          :items="requestForQuotationHistory"
          :search="quotationSearch"
          @onQuotationClick="getQuotationDetails"
        />
      </v-card>

      <products-order-modal
        v-model="dialog"
        :products="pedidoInfo"
        :order-number="pedidoSelect"
        :total="pedidoImporte"
      />

      <!-- Dialog -->
      <v-row justify="center">
        <v-dialog
          v-model="dialog_delivery"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar dark color="indigo">
              <v-btn icon dark @click="dialog_delivery = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>
                Pedido:{{ pedidoSelect }} Entrega:
                {{ deliverySelect }}
              </v-toolbar-title>
              <v-spacer />
            </v-toolbar>
            <p />
            <v-simple-table dense>
              <thead>
                <tr>
                  <th class="text-left">CODIGO</th>
                  <th class="text-left">DESCRIPCION</th>
                  <th class="text-left">CANTIDAD</th>
                  <th class="text-left">CENTRO</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in deliveryInfo" :key="item.MATNR">
                  <td class="text-left">
                    {{ parseInt(item.MATNR) }}
                  </td>
                  <td class="text-left">
                    {{ item.ARKTX }}
                  </td>
                  <td class="text-left">
                    {{ item.LFIMG }}
                  </td>
                  <td class="text-left">
                    {{ item.WERKS }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- /. Dialog -->
      <!-- Dialog loading -->
      <v-row justify="center">
        <v-dialog v-model="loading" hide-overlay persistent width="300">
          <v-card color="primary" dark>
            <v-card-text>
              Cargando
              <v-progress-linear indeterminate color="white" class="mb-0" />
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
      <v-dialog v-model="dialog_email" width="500" persistent>
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Enviar por Correo
          </v-card-title>
          <v-card-text>
            <p />
            <h6 style="text-align: left; font-weight: 700">
              Factura: {{ invoice }}
            </h6>
            <p />
            <v-row>
              <v-col md="12">
                <div class="form-group">
                  <label>Ingresar Email:</label>
                  <v-text-field v-model="emai_user" solo>
                    {{ emai_user }}
                  </v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-btn color="error" text @click="close2()"> Cancelar </v-btn>
            <v-spacer />
            <v-btn color="success" text @click="sendEmailXMLPDF(invoice)">
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
  import axios from '@/plugins/axios';
  import { mapGetters, mapActions } from 'vuex';
  import RequestForQuotationTable from '@/components/tables/RequestForQuotationTable.vue';
  import SearchInput from '@/components/SearchInput.vue';
  import ProductsOrderModal from '@/components/modals/ProductsOrderModal.vue';
  import RecentOrdersViewer from './components/RecentOrdersViewer.vue';
  import OrderHistoryTable from '@/components/tables/OrderHistoryTable.vue';
  import DateRangeSelector from '@/components/DateRangeSelector.vue';
  import maintenance from '@/mixins/maintenance';

  import moment from 'moment';
  export default {
    components: {
      RequestForQuotationTable,
      SearchInput,
      ProductsOrderModal,
      OrderHistoryTable,
      DateRangeSelector,
      RecentOrdersViewer,
    },
    mixins: [maintenance],
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        if (
          from.name === 'NewShoppingCartBackPR' ||
          from.name === 'NewShoppingCartBack'
        ) {
          vm.loadReminders();
          vm.loadRemindersStep();
        }
      });
    },
    data: () => ({
      id_order: null,
      comments: 'A1 = Canc. Rec. Por Falt. Inventario',
      dialogSpecilaOrder: false,
      comments_0: null,
      purchase_order: null,
      invoice: null,
      dialog_email: false,
      selected: [],
      orderShop: [],
      order_array: [],
      disabledCount: 0,
      data: [],
      dialog: false,
      dialog_delivery: false,
      search: '',
      menu1: false,
      menu2: false,
      message_order: '',
      emai_user: null,
      itemCSV: [],

      loading3: false,
      loading: false,
      pedidoSelect: null,
      pedidoInfo: [],
      pedidoImporte: null,
      item: {},
      customer_code: null,
      sellerOrderAviable: true,
      today2: moment().format('YYYY/MM/DD'),
      deliverySelect: null,
      deliveryInfo: null,
      deliveryAmount: null,
      status: false,
      material_val: [],
      requestForQuotationHistory: [],
      quotationSearch: '',
      orderToDelete: {},
      startDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
    }),
    computed: {
      ...mapGetters({
        user: 'auth/user',
      }),
      ...mapGetters('selectedUser', [
        'loadCustomerError',
        'noCustomerSelected',
      ]),
    },
    watch: {
      data: {
        immediate: true,
        handler() {
          this.generarExcel();
        },
      },
    },
    mounted() {
      if (this.$hasAnyRole(['Customer', 'CustomerPR'])) {
        this.customer_code = this.user.custumer_code;
      } else {
        const currentCustomerCode =
          JSON.parse(localStorage.getItem('currentCustomerCode')) || [];
        if (currentCustomerCode.length < 1) {
          this.$router.push({ name: 'Home' });
        }
        const currentCustomerInfo =
          JSON.parse(localStorage.getItem('currentCustomerInfo')) || [];
        if (currentCustomerInfo.length < 1) {
          this.$router.push({ name: 'Home' });
        }
        this.customerInfo = currentCustomerInfo;
        this.customer_code = currentCustomerCode;
      }
      this.getPedidoHistory(this.startDate, this.endDate);
      this.emai_user = this.user.email;
      this.getRequestForQuoatationHistory();
      this.generarPDF();

      // Slides to a specific id on the view, when comming from backorders blocking message it slides to backorders table
      if (this.$route.params.scrollTo) {
        document.getElementById(this.$route.params.scrollTo).scrollIntoView();
      }
    },
    methods: {
      ...mapActions({
        sendToPDF: 'printer/sendToPDF',
        sendToExcel: 'printer/sendToExcel',
      }),
      ...mapActions('reminders', [
        'removeReminder',
        'loadReminders',
        'loadRemindersStep',
      ]),
      ...mapActions('selectedUser', [
        'loadCustomer',
        'setSelectedCustomerCode',
      ]),
      async deleteReminder(reasonsForm) {
        const deleteReminderData = {
          reminders: this.orderToDelete,
          reasonsForm,
        };

        this.orderToDelete.loading = true;
        try {
          await this.removeReminder(deleteReminderData); // Removes reminder from store
          this.orderToDelete.deleted = true;
        } catch (error) {
          this.orderToDelete.error = true;
        }

        this.orderToDelete.loading = false;
      },
      async loadReminderCustomer() {
        await this.setSelectedCustomerCode(
          this.firstReminderSelected.customer.code
        );
        await this.loadCustomer();

        if (this.noCustomerSelected || this.loadCustomerError)
          throw 'Error al cargar el cliente';
      },
      generarPDF() {
        this.sendToPDF({ active: true });
      },
      generarExcel() {
        let newItems = [];
        this.itemCSV = [];

        for (let key in this.data) {
          let item = this.data[key];
          newItems.push({
            Fecha: item.fecha,
            Consec: item.consec,
            'Orden de compra': item.orden,
            Pedido: item.pedido,
            Entrega: item.entrega,
            'Factura.': item.factura,
            Estatus: item.estatus,
          });
        }
        this.itemCSV = newItems;

        let objectCSV = {
          name: `Hist. Pedidos-${this.today2}`,
          items: this.itemCSV,
          showLabels: true,
        };

        this.sendToExcel(objectCSV);
      },
      getHistoryByDate({ startDate, endDate }) {
        this.startDate = startDate;
        this.endDate = endDate;

        this.getPedidoHistory(startDate, endDate);
      },
      async getPedidoHistory(startDate, endDate) {
        this.loading3 = true;

        const params = {
          customer: this.customer_code,
          channel: this.user.VTWEG,
          date_start: startDate,
          date_end: endDate,
        };

        try {
          const response = await axios.post('/getPedidoHistory', params);
          this.loading3 = false;
          this.data = response.data;
        } catch (error) {
          this.error = 'No se pudo obtener el estado de cuenta';
        }
      },

      async getRequestForQuoatationHistory() {
        const history = await axios.get(
          `/request-for-quotation/customer-history/${this.customer_code}`
        );
        this.requestForQuotationHistory = history.data;
      },

      async getQuotationDetails(quotationId) {
        const quotation = { pedido: quotationId };
        this.detallePedido(quotation);
      },

      detallePedido(item) {
        this.pedidoSelect = item.pedido;
        this.dialog = true;
        this.loading = true;
        axios
          .post('getInfoPedido', {
            id_pedido: item.pedido,
            //cliente: this.user.custumer_code,
            cliente: this.customer_code,
          })
          .then((response) => {
            this.loading = false;
            this.pedidoInfo = response.data.prueba_Pedido;
            this.pedidoImporte = response.data.importe;
            this.pedidoInfo.pop();
          })
          .catch(() => {
            this.loading = false;
            //alert(error);
          })
          .finally(() => (this.loading = false));
      },

      deliveryDetail(item) {
        this.deliverySelect = item.entrega;
        this.pedidoSelect = item.pedido;
        this.dialog_delivery = true;
        this.loading = true;
        axios
          .post('getDeliveryDetail', {
            delivery: item.entrega,
          })
          .then((response) => {
            this.loading = false;
            this.deliveryInfo = response.data.delivery_detail;
            this.deliveryAmount = response.data.importe;
            this.deliveryInfo.pop();
          })
          .catch(() => {
            this.loading = false;
            //alert(error);
          })
          .finally(() => (this.loading = false));
      },

      senDEmail(item) {
        this.invoice = item.factura;
        //this.id_order = item.id;
        this.dialog_email = true;
      },
      senDEmailComp(item) {
        this.invoice = item.pay_complement;
        //this.id_order = itto em.id;
        this.dialog_email = true;
      },
      close2() {
        this.dialog_email = false;
      },
      async getPDFXMLInvoice(invoice, type) {
        this.dialog_email = false;
        const newWindow = window.open('', '_blank');

        const params = {
          invoice: invoice,
          type: type,
        };

        try {
          const response = await axios.post('/InvoicePDFXML', params);
          this.url = (response.data || '').trim();

          if (!this.url) {
            if (newWindow) newWindow.close();
            this.error = 'No se pudo obtener el archivo';
            return;
          }

          if (newWindow) {
            newWindow.location.href = this.url;
          } else {
            window.location.href = this.url;
          }
        } catch (error) {
          this.error = 'No se pudo obtener el estado de cuenta';
        }
      },
      sendEmailXMLPDF(invoice) {
        this.dialog_email = false;
        axios
          .post('InvoicePDFXMLEmail', {
            invoice: invoice,
            email: this.emai_user,
          })
          .then((response) => {
            this.message = response.data;

            this.$swal({
              title: response.data.message,
              icon: 'success',
              type: 'succes',
            }).then(function () {
              //this.getRecordatoriosHistory();
            });
          })
          .catch(() => {
            // TODO: resolve error
          });
      },
      hideTableHeaders() {
        if (this.$hasAnyRole(['Customer', 'CustomerPR'])) {
          return ['seller', 'manager', 'customer', 'regManager'];
        }
        if (
          this.$hasAnyRole([
            'Seller',
            'Manager',
            'Submanager',
            'RegionalManager',
            'IELExpressSales',
            'CreditAssistant',
          ])
        ) {
          return ['manager', 'seller', 'regManager'];
        }
      },
    },
  };
</script>
<style scoped>
  .search-input-width {
    width: 350px;
  }
  .rounded-when-no-title {
    border-radius: 4px;
  }
  .shadow-in {
    box-shadow: inset 0px 2px 6px #00000029, 0px 2px 6px #00000029;
  }
</style>
